/**
 * If the theme header is not a <sticky-header> instance, toggle the solid sticky bar
 * once the editorial collection hero has scrolled past the top of the viewport.
 */
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('sticky-header')) return;

  const hero = document.querySelector('#MainContent > .shopify-section.aelein-collection-hero:first-child');
  const headerSection = document.querySelector('.shopify-section.section-header');
  if (!hero || !headerSection) return;

  if (!headerSection.querySelector('.header-wrapper--luxury-transparent')) return;

  const apply = () => {
    const rect = hero.getBoundingClientRect();
    const solid = rect.bottom <= 1;
    headerSection.classList.toggle('shopify-section-header-sticky', solid);
  };

  window.addEventListener('scroll', apply, { passive: true });
  window.addEventListener('resize', apply);
  apply();
});
